module.exports = __webpack_public_path__ + "img/2_Website_Banner_boy_gold.4e9ea7c0.jpg";